<template>
  <div>
    <p class="xPadding titleModal">
      {{
        $t(`treatmentProgram.step3.targetDosage`)
      }}
    </p>
    <v-row class="xPadding">
      <v-col
        class="noYPadding"
        cols="12"
        sm="6"
      >
        <VTextField
          v-model="data.dosage.value"
          :label="$t('treatmentProgram.step3.dosage')"
          :formatNumber="true"
          type="number"
          min="0"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          data-cy="targetDosage-dosageValue"
          @input="updateData"
        />
      </v-col>
      <v-col
        class="noYPadding"
        cols="12"
        sm="6"
      >
        <VSelect
          v-model="data.dosage.unit"
          :label="$t('treatmentProgram.step2.unit')"
          :items="displayedUnits('dosageUnit')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="targetDosage-dosageUnit"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <!-- End dosage target -->
    <!-- Injection target -->
    <p class="xPadding titleModal">
      {{
        $t(`treatmentProgram.step3.injectionCible`)
      }}
    </p>
    <v-row class="xPadding">
      <v-col
        class="noYPadding"
        cols="12"
        sm="6"
      >
        <VTextField
          v-model="data.injectionCible.value"
          :label="$t('treatmentProgram.step3.injectionCible')"
          :formatNumber="true"
          type="number"
          min="0"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          data-cy="targetDosage-injectionValue"

          @input="updateData"
        />
      </v-col>
      <v-col
        class="noYPadding"
        cols="12"
        sm="6"
      >
        <VSelect
          v-model="data.injectionCible.unit"
          :label="$t('treatmentProgram.step2.unit')"
          :items="displayedUnits('injectionCibleUnit')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="targetDosage-injectionUnit"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <!-- End Injection target -->
    <!-- Pump -->
    <p class="xPadding titleModal">
      {{
        $t(`treatmentProgram.step3.pump`)
      }}
    </p>
    <v-row class="xPadding">
      <v-col
        class="noYPadding"
        cols="12"
        sm="6"
      >
        <VTextField
          v-model="data.modelPump"
          :label="$t('treatmentProgram.step3.modelPump')"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          data-cy="targetDosage-pumpUnit"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        class="noYPadding"
        cols="12"
        sm="6"
      >
        <VTextField
          v-model="data.maxPressure.value"
          :label="$t('treatmentProgram.step3.maxPressure')"
          :formatNumber="true"
          type="number"
          min="0"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          data-cy="targetDosage-maxPressureValue"
          @input="updateData"
        />
      </v-col>
      <v-col
        class="noYPadding"
        cols="12"
        sm="6"
      >
        <VSelect
          v-model="data.maxPressure.unit"
          :label="$t('treatmentProgram.step2.unit')"
          :items="displayedUnits('maxPressureUnit')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="targetDosage-maxPressureUnit"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        class="noYPadding"
        cols="12"
        sm="6"
      >
        <VTextField
          v-model="data.maxCapacity.value"
          :label="$t('treatmentProgram.step3.maxCapacity')"
          :formatNumber="true"
          type="number"
          min="0"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          data-cy="targetDosage-maxCapacityValue"

          @input="updateData"
        />
      </v-col>
      <v-col
        class="noYPadding"
        cols="12"
        sm="6"
      >
        <VSelect
          v-model="data.maxCapacity.unit"
          :label="$t('treatmentProgram.step2.unit')"
          :items="displayedUnits('maxCapacityUnit')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="targetDosage-maxCapacityUnit"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        class="noYPadding"
        cols="12"
        sm="6"
      >
        <VTextField
          v-model="data.realFlow.value"
          :label="$t('treatmentProgram.step3.realFlow')"
          :formatNumber="true"
          type="number"
          min="0"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          data-cy="targetDosage-realFlowValue"
          @input="updateData"
        />
      </v-col>
      <v-col
        class="noYPadding"
        cols="12"
        sm="6"
      >
        <VSelect
          v-model="data.realFlow.unit"
          :label="$t('treatmentProgram.step2.unit')"
          :items="displayedUnits('realFlowUnit')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="targetDosage-realFlowUnit"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        class="noYPadding"
        cols="12"
        sm="6"
      >
        <VTextField
          v-model="data.volumeSystem.value"
          :label="$t('treatmentProgram.step3.volumeSystem')"
          :formatNumber="true"
          type="number"
          min="0"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          data-cy="targetDosage-volumeSystemValue"
          @input="updateData"
        />
      </v-col>
      <v-col
        class="noYPadding"
        cols="12"
        sm="6"
      >
        <VSelect
          v-model="data.volumeSystem.unit"
          :label="$t('treatmentProgram.step2.unit')"
          :items="displayedUnits('volumeSystemUnit')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="targetDosage-volumeSystemUnit"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <!-- End Pump -->
    <!-- Time -->
    <p class="xPadding titleModal">
      {{
        $t(`treatmentProgram.step3.time`)
      }}
    </p>
    <v-row class="xPadding">
      <v-col
        class="noYPadding"
        cols="12"
        sm="6"
      >
        <VTextField
          v-model="data.residenceTimeOfSytem.value"
          :label="$t('treatmentProgram.step3.residenceTimeOfSytem')"
          :formatNumber="true"
          type="number"
          min="0"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          data-cy="targetDosage-residenceTimeOfSytemValue"

          @input="updateData"
        />
      </v-col>
      <v-col
        class="noYPadding"
        cols="12"
        sm="6"
      >
        <VSelect
          v-model="data.residenceTimeOfSytem.unit"
          :label="$t('treatmentProgram.step2.unit')"
          :items="displayedUnits('residenceTimeOfSytemUnit')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="targetDosage-residenceTimeOfSytemUnit"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        class="noYPadding"
        cols="12"
        sm="6"
      >
        <VTextField
          v-model="data.halfLife.value"
          :label="$t('treatmentProgram.step3.halfLife')"
          :formatNumber="true"
          type="number"
          min="0"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          data-cy="targetDosage-halfLifeValue"
          @input="updateData"
        />
      </v-col>
      <v-col
        class="noYPadding"
        cols="12"
        sm="6"
      >
        <VSelect
          v-model="data.halfLife.unit"
          :label="$t('treatmentProgram.step2.unit')"
          :items="displayedUnits('halfLifeUnit')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="targetDosage-halfLifeUnit"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <!-- End Time -->
  </div>
</template>
<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';

export default {
    name: 'TargetDosage',
    components: {
        VTextField,
    },
    props: {
        targetDosage: {
            type: Object,
            default: () => {},
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: [],
        };
    },
    computed: {
        ...mapGetters([
            'treatmentProgramUnits',
        ]),
    },
    watch: {
        targetDosage: {
            handler() {
                this.data = { ...this.data, ...cloneDeep(this.targetDosage) };
            },
            immediate: true,
        },
    },
    methods: {
        updateData() {
            this.$emit('sendData', { targetDosage: this.data });
        },
        displayedUnits(type) {
            return this.treatmentProgramUnits && this.treatmentProgramUnits[type] ? this.treatmentProgramUnits[type] : [];
        },
    },
};
</script>
<style lang="scss" scoped>
.xPadding{
  padding: 0 6rem;
}
@media screen and (max-width: 960px) {
  .xPadding{
    padding: 0;
  }
}
.btn-container {
  display: flex;
  align-items: baseline;
  padding: 0;
}
.noYPadding {
  padding-bottom: 0px;
  padding-top: 0px;
}
@media screen and (max-width: 600px) {
   .xPadding{
      padding: 0;
    }
}
</style>
